import React from 'react'
import { Col, Modal, Row } from 'react-bootstrap'
import { ImCross } from 'react-icons/im'
import reactSelect from 'react-select'


const VendorDetailModal = (props) => {
    const { show, handleClose, data, routes } = props

    return (
        <Modal
            size="lg"
            show={show}
            onHide={() => handleClose()}
            aria-labelledby="example-modal-sizes-title-lg"
            centered
        >
            <Modal.Header className='px-0'>
                <Modal.Title className='modal-title px-4' id="example-modal-sizes-title-lg">
                    Vendor Details
                </Modal.Title>
                <button className="modal-close-btn me-4 text-center" onClick={handleClose}>
                    <ImCross color='#fff' size={12} />
                </button>
            </Modal.Header>
            <Modal.Body className='px-4 justify-content-center'>
                <Row>
                    <Col md={4}>
                        <div className='modal-small-heading'>Name</div>
                        <div className="modal-detail-value">{data?.name}</div>
                    </Col>

                    <Col md={4}>
                        <div className='modal-small-heading'>Status</div>
                        <div className="modal-detail-value">{data?.status}</div>
                    </Col>


                    <Col md={4}>
                        <div className='modal-small-heading'>Transit Type</div>
                        <div className="modal-detail-value">{data?.transit_type}</div>
                    </Col>
                </Row>


            </Modal.Body>
        </Modal>
    )
}

export default VendorDetailModal